import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=d4b8a490&scoped=true&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"
import style0 from "./Profile.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Profile.vue?vue&type=style&index=1&id=d4b8a490&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b8a490",
  null
  
)

export default component.exports